import Dict from '@/utils/dict-utils'

// 发布方式
export const publishMethodDict = new Dict({
  NOTICE: {
    label: '招标公告',
    value: 0
  },
  INVITATION: {
    label: '邀请函',
    value: 1
  }
})

// 中标方式
export const winningMethodDict = new Dict({
  TOTAL_PRICE: { label: '总价', value: 1 },
  UNIT_PRICE: { label: '单价', value: 2 },
  SHORTLIST: { label: '入围', value: 3 },
  RATE: { label: '费率', value: 4 }
})

// 项目来源
export const projectSourceDict = new Dict({
  RECORDED: { label: '备案采购', value: 1 },
  OFF_THE_RECORD: { label: '非备案采购', value: 0 }
})

// 组织方式
export const queryOrganizationDict = new Dict({
  ENTRUST: {
    label: '委托采购',
    value: 1
  },
  SELF_SOURCING: {
    label: '自主采购',
    value: 0
  }
})

// 项目状态
export const projectStatusDict = new Dict({
  REGISTERING: {
    label: '报名中',
    value: 1,
    type: 'primary'
  },
  PUBLIC_PERIOD: {
    label: '公示期',
    value: 3,
    type: 'warning'
  },
  FINISHED: {
    label: '已完结',
    value: 4,
    type: 'success'
  },
  RESTART: {
    label: '重新采购',
    value: 6,
    type: 'danger'
  },
  TERMINATION: {
    label: '终止采购',
    value: 5,
    type: 'danger'
  }
})

// 项目查询方式字典
export const queryMethodDict = new Dict({
  PURCHASE: {
    value: 0,
    label: '采购项目查询',
    routePrefix: ''
  },
  AGENCY: {
    value: 1,
    label: '代理项目查询',
    routePrefix: 'Agency'
  }
})

// bi面板 pageId
export const biPageIdObj = {
  // 测试环境
  test: {
    // 协同及未协同项目分析
    collaborationProjectAnalysis: 'df0b484c-7e9b-4142-9229-39fcb71454b8'
  },
  // 生产环境
  production: {
    collaborationProjectAnalysis: '2456080f-87a7-43b9-a1ae-2bd1ed35cf89',
    // 供应商分析分析
    supplierAnalysisJxic: '900c155b-5d87-47ae-be09-a4816bca5ff0', // 省投
    supplierAnalysisNoJxic: '705c4527-97fc-4759-bd94-68541231df33', // 非省投

    // 代理机构分析
    agencyAnalysisJxic: 'f411dfb6-1e50-4e21-ab0b-6afe5af7f23f', // 省投
    agencyAnalysisNoJxic: '45c84eda-df95-4c30-96f4-e77749005aec' // 非省投
  }
}
